export default __webpack_public_path__ + "static/media/onthouden.066e4b09.png";